import dayjs, { ConfigType, Dayjs } from 'dayjs';

export const getIsDateInPast = (date?: ConfigType | null): boolean =>
  dayjs(date ?? undefined).isBefore(dayjs().subtract(1, 'minute'));
export const getFormattedDate = (date?: Dayjs | Date | null): string | null => (date ? date.toISOString() : null);

export const getHoursDifference = (givenDate: ConfigType): number => dayjs().diff(dayjs(givenDate), 'hour', true);
